

export default function fixIframeRatio () {
    document.querySelectorAll('iframe')
        .forEach(iframe => {
            if ( iframe.width && iframe.height ) {
                if ( iframe.offsetWidth !== iframe.width ) {
                    const ratio =  iframe.offsetWidth / iframe.width;
                    iframe.style.height = iframe.height * ratio +'px';
                }
            }
        });
}
